/**
 * Moduł modali
 */
angular.module('lsnBase.modal', [
  'angular-ladda'
  ]);